import { render, staticRenderFns } from "./emailCheckboxItem.vue?vue&type=template&id=4cfeaac2"
import script from "./emailCheckboxItem.vue?vue&type=script&lang=js"
export * from "./emailCheckboxItem.vue?vue&type=script&lang=js"
import style0 from "./emailCheckboxItem.vue?vue&type=style&index=0&id=4cfeaac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports